import React from 'react';
import Control from 'react-leaflet-custom-control';
import { Box, ToggleButton, Tooltip, alpha } from '@mui/material';
import { useSelector } from 'react-redux';
import { setFilter } from '../../store/storeSlice';
import { useDispatch } from 'react-redux';

const SeverityControl = ({ position = 'bottomleft' }) => {
    const objects = useSelector(state => state.store.objects);
    const hosts = objects.hosts
    const filter = useSelector(state => state.store.filter);
    const dispatch = useDispatch();


    const severities = [
        { level: 0, color: "#009549", name: "Все" },
        { level: 1, color: "#28a1d7", name: "Информация" },
        { level: 2, color: "#f5bb3a", name: "Предупреждение" },
        { level: 3, color: "#ef9227", name: "Средняя" },
        { level: 4, color: "#d63a23", name: "Высокая" },
        { level: 5, color: "#a23337", name: "Критическая" },
    ];


    const handleSeverityChange = (severity) => {
        dispatch(setFilter({ ...filter, severity: severity.level }));
    };

    return (
        <Control position={position}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'var(--background-paper)',
                    borderRadius: { xs: '6px', md: '8px' },
                    boxShadow: 'var(--shadow-md)',
                    border: '1px solid var(--border-default)',
                    backdropFilter: 'blur(20px)',
                    WebkitBackdropFilter: 'blur(20px)',
                    p: { xs: 0.5, md: 0.6 },
                    gap: { xs: 0.4, md: 0.5 }
                }}
            >
                {severities.map((severity) => (
                    <Tooltip
                        key={severity.name}
                        title={`${severity.name} (уровень ${severity.level})`}
                        placement="top"
                    >
                        <ToggleButton
                            value={severity.level}
                            selected={filter.severity <= severity.level}
                            onChange={() => handleSeverityChange(severity)}
                            sx={{
                                width: { xs: '14px', md: '20px'},
                                height: { xs: '14px', md: '20px'},
                                minWidth: { xs: '14px', md: '20px'},
                                minHeight: { xs: '14px', md: '20px'},
                                padding: 0,
                                margin: 0,
                                borderRadius: '50%',
                                border: `2px solid ${severity.color}`,
                                borderWidth: { xs: '2px', md: '3px' },
                                borderColor: severity.color,
                                backgroundColor: 'transparent',
                                '&:hover': {
                                    backgroundColor: alpha(severity.color, 0.2),
                                    borderColor: severity.color,
                                    transform: 'scale(1.1)',
                                    transition: 'all 0.2s ease-in-out',
                                },
                                '&.Mui-selected': {
                                    backgroundColor: severity.color,
                                    borderColor: severity.color,
                                    boxShadow: { 
                                        xs: `0 0 6px ${alpha(severity.color, 0.5)}`,
                                        md: `0 0 8px ${alpha(severity.color, 0.5)}`
                                    },
                                    '&:hover': {
                                        backgroundColor: severity.color,
                                        filter: 'brightness(0.9)',
                                        transform: 'scale(1.05)',
                                    },
                                },
                                '&:not(.Mui-selected)': {
                                    opacity: filter.severity < severity.level ? 0.4 : 1,
                                }
                            }}
                        />
                    </Tooltip>
                ))}
            </Box>
        </Control>
    );
};

export default SeverityControl; 